import * as actions from "./../common/actions";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { All } from "../interfaces";
import SelectSection from "../components/SectionSelect";

export function mapStateToProps({ appState }: All) {
  return {
    selectedDisplayValues: (appState as any)[appState.app].displayFields
      ? (appState as any)[appState.app].displayFields
      : [""],
    selectedStateValues: (appState as any)[appState.app].filters[
      appState.app === "historical" ? "selectedStates" : "selectedStatesAlpha"
    ]
      ? (appState as any)[appState.app].filters[
          appState.app === "historical"
            ? "selectedStates"
            : "selectedStatesAlpha"
        ]
      : [undefined],
    selectedInsuranceFunds: (appState as any)[appState.app].filters
      .selectedInsuranceFunds
      ? (appState as any)[appState.app].filters.selectedInsuranceFunds
      : [undefined],
    selectedCharterTypes: (appState as any)[appState.app].filters
      .selectedCharterTypes
      ? (appState as any)[appState.app].filters.selectedCharterTypes
      : [undefined],
    selectedTransactionTypes: (appState as any)[appState.app].filters
      .selectedTransactionTypes
      ? (appState as any)[appState.app].filters.selectedTransactionTypes
      : [undefined],
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onAdd: (
      values: string[] | number[],
      currentReport: string,
      filterField?: string,
      updateReport?: boolean,
    ) => {
      dispatch(actions.addValues(values, filterField));
      if (filterField) {
        dispatch(actions.updatePagination("pageNumber", 1));
      }
      //updates reports for historical data. CB or SI
      if (updateReport) {
        dispatch(actions.updateFilter("selectedReport", currentReport));
      }
      dispatch(actions.searchPush());
    },
    onRemove: (
      values: string[] | number[],
      currentReport?: string,
      filterField?: string,
      updateReport?: boolean,
    ) => {
      dispatch(actions.removeValues(values, filterField));
      if (filterField) {
        dispatch(actions.updatePagination("pageNumber", 1));
      }
      if (updateReport) {
        dispatch(actions.updateFilter("selectedReport", currentReport));
      }
      dispatch(actions.searchPush());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectSection);
